module.exports = __webpack_public_path__ + "img/icon5.5dd4605b.png";